<template>
    <div class="sign">
        <canvas id="canvas" ref="canvas" :width="width" :height="height" />
        <div>
            <button id="clear" type="button" @click="clear">清空</button>
            <button id="save" type="button" @click="save">保存</button>
        </div>
        <div v-show="false" class="saveimgs">
            <span id="saveimgs_child" />
        </div>
    </div>
</template>

<script>
/*
  * width   canvas 宽度
  * height  canvas 高度
  * strokeStyle  线条颜色
  * showUrl   是否显示预览图片
  * imgWidth  img 宽度
  * imgHeight img 高度
  * draw_clear   //监听清空事件
  * draw_save    //监听保存事件 返回base64 img 路径
  * */
var preHandler = function(e) { e.preventDefault() }
export default {
    name: 'DrawSign',
    props: {
        width: {
            type: String,
            default: '330'
        },
        height: {
            type: String,
            default: '500'
        },
        strokeStyle: {
            type: String,
            default: 'red'
        },
        showUrl: {
            type: Boolean,
            default: true
        },
        imgWidth: {
            type: String,
            default: '240'
        },
        imgHeight: {
            type: String,
            default: '106'
        }
    },
    data() {
        return {
            canvas: null, // canvas
            ctx: null, // ctx canvas对象
            stroke_info: null, // 当前绘图的坐标
            url: '' // base64 图像
        }
    },

    mounted() {
        this.$nextTick(_ => {
            this.init()
        })
    },
    methods: {
        init() {
            const that = this
            this.canvas = document.getElementById('canvas')
            this.ctx = this.canvas.getContext('2d')
            this.stroke_info = this.canvas.getBoundingClientRect()
            this.canvas.addEventListener('touchstart', function(event) {
                document.addEventListener('touchStart', preHandler, false)
                that.darwStart(event)
            })
            this.canvas.addEventListener('touchend', function(event) {
                document.addEventListener('touchend', preHandler, false)
                that.drawEnd()
            })
            this.clear()
        },
        darwStart(e) {
            const that = this
            const t = e.changedTouches[0]
            // console.log(t.clientX, t.clientY);
            this.ctx.strokeStyle = this.strokeStyle
            this.ctx.beginPath() // 清空所有绘画路径
            this.ctx.moveTo(t.clientX - this.stroke_info.left, t.clientY - this.stroke_info.top)
            this.canvas.addEventListener('touchmove', function(event) {
                that.darwMove(event)
            })
        },
        darwMove(e) {
            const t = e.changedTouches[0]
            this.ctx.lineTo(t.clientX - this.stroke_info.left, t.clientY - this.stroke_info.top)
            this.ctx.stroke()
        },
        drawEnd() {
            document.removeEventListener('touchstart', preHandler, false)
            document.removeEventListener('touchmove', preHandler, false)
            document.removeEventListener('touchend', preHandler, false)
        },
        clear() {
            this.ctx.clearRect(0, 0, this.width, this.height)
            this.url = ''
            this.$emit('draw_clear')
        },
        save() {
            console.log(this)
            const image = this.$refs.canvas.toDataURL('image/png')
            this.isSuccess = true
            console.log(image)
            /* var ctximg = document.getElementById('saveimgs_child') // createElement("span");
            this.saveimgs = document.getElementsByClassName('saveimgs')[0]
            ctximg.innerHTML = "<img src='" + image + "' alt='from canvas'/>"
            if (document.getElementById('saveimgs_child') != null) {
                var span_old = document.getElementById('saveimgs_child')
                this.saveimgs.replaceChild(ctximg, span_old)
            } else {
                this.saveimgs.appendChild(ctximg)
            }*/
            // let query = {url: data}
            this.$emit('draw_save', image)
            this.ctx.clearRect(0, 0, this.width, this.height)
            this.url = ''
            // $emit 传data给父组件，当签名签完了之后，会保存图片的，data是base64编码，图片img src直接可识别
            // console.log(this.canvas);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #clear,#save{
   width:270px;
   height:50px;
   line-height:50px;
   font-size:0.6rem;
   position:absolute;
  }
  #clear{
   bottom:0;
  }
  #save{
   bottom:0;
   right:0;
  }
</style>
